<template lang="pug">
  include /mixins
  div
    +b.tt-checkout-detail-info
      +e.title.P {{ _('Ваш кешбек') }}
      +e.content
        +b.g-row
          +b.g-cell.g-cols--6
            +b.tt-order-info-tail
              +e.title.P {{ _('Всего') }}
              +e.value.P(
                v-html='getSplittedHtml(externalUser.props && externalUser.props.bonus_sum  || 0)'
              )
          +b.g-cell.g-cols--6
            +b.tt-order-info-tail
              +e.title.P {{ _('Доступно к списанию') }}
              +e.value.P(
                v-html='getSplittedHtml(info && info.order_available_bonus  || 0)'
              )
    +b.tt-checkout-detail-info
      +e.title.P {{ _('Списать кешбек') }}
      +e.content
        +b.VALIDATION-OBSERVER(
          ref="validator",
          v-slot="{ valid, errors }",
          tag="form",
          autocomplete='off'
        )
          div
            ui-loader(v-if='isLoad')
            //- +b.ds-caption--size_md.tt-space_mb--1.P {{ _('На вашем счету') }} #[strong(v-html='getSplittedHtml(externalUser.props && externalUser.props.bonus_sum  || 0)')] {{ _('бонусов') }}
            //- +b.ds-caption--size_xs.P(
            //-   v-if='!showDescription'
            //- ) {{ _('Максимальное количество бонусов, которое вы можете использовать для этого заказа: ') }} #[strong(v-html='getSplittedHtml(info && info.order_available_bonus  || 0)')]
            .relative(v-if='bonus && errors.bonus_sum && errors.bonus_sum.length ')
              +b.error-label.LABEL() {{ errors.bonus_sum[0] }}
            row(
              appearance='nowrap'
              v-if='bonus'
            )
              cell.full-w(cols='')
                +b.d-control-input--appearance_bordered
                  +e.element(name='coupon' value='test' disabled='true' readonly='readonly' rules='required') {{ Number(bonus).toFixed(2) }}
                  label.d-control-input__label--active.d-control-input__label.d-control-input__label--bound(for='coupon') {{ _("Бонусов к списанию:") }}

              cell(cols='narrow')
                +b.tt-button--for-input.--appearance_free.d-control-button.BUTTON(
                    type='submit',
                    @click.prevent='removePromo()'
                  )
                    +e.title.P.mdi.mdi-close
            row(
              appearance='nowrap'
              v-show='!bonus'
            )
              cell.full-w(cols='')
                +b.d-control-input--appearance_bordered.D-CONTROL-INPUT(
                  :input-label='_("Сумма бонусов")'
                  v-model='form.bonus_sum'
                  id='bonus_sum',
                  ref='bonus_sum',
                  name='bonus_sum',
                  type='number'
                  :rules='{ max_value_bonuses: userBonus }'
                  :max='userBonus'
                  @input='setMax'
                )
                .relative(v-if="non_field_errors")
                  +b.error-label.LABEL {{ non_field_errors[0] }}
              cell(cols='narrow')
                +b.tt-button--for-input.--appearance_free.d-control-button.LOADER-BTN(
                  type='submit',
                  :disabled='isLoad || !form.bonus_sum',
                  :action='() => prepareData(valid)'
                  :title="_('Применить')"
                  :load='isLoad'
                )

</template>

<script>
import pathOr from 'ramda/src/pathOr';
import { applyBonuses } from '@api/order.service';
import { updateUserData } from '@api/staff.service';

import FormMixin, { defaultValidatorErrorsParser } from '@app/Forms/FormMixin';
import { mapState, mapActions, mapMutations } from 'vuex';

import { confirmWithPromise } from '@utils/helpers';

import { getCookie } from '@utils/cookies';

import { COUNTRY_CODE_COOKIE_NAME } from '@app/consts';

const MAX_PERCENT = '100.00';

export default {
  name: 'Bonus',
  mixins: [FormMixin],
  props: ['phone', 'bonus', 'cartChange', 'balance'],
  data() {
    return {
      form: {
        bonus_sum: '',
      },
      isLoad: false,
      non_field_errors: '',
      type: window.coupon,
      labels: {
        promo_exist: this._('ИСПОЛЬЗОВАН ПРОМО-КОД: '),
        promo: this._('Введіть промокод (якщо є)'),
      },
      info: {},
      externalUser: {},
      bonus_value: null,
    };
  },
  watch: {
    cartChange: {
      async handler() {
        console.log(this.cartChange, '----------CART CHANGE -------------');
        let data = (await this.prepareData(true, { bonus_sum: this.bonus || 0 }))
        if (data.bonus_sum) {
          if (data.bonus_sum > data.order_available_bonus) {
            data = (await this.prepareData(true, { bonus_sum: data.order_available_bonus || 0 }))
          }
          this.form.bonus_sum = Number(data.bonus_sum.toFixed(2))
          this.bonus_value = data.bonus_sum
        }
        if (this.form.bonus_sum) {
          console.log(data, '****');
        }
        // this.send({ bonus_sum: this.bonus });
      },
    },
  },
  computed: {
    ...mapState('cart', ['cart', 'coupon']),
    ...mapState('staff', ['user']),
    userBonus() {
      return Number(Math.min(
        pathOr(0, ['order_available_bonus'], this.info),
        pathOr(0, ['props', 'bonus_sum'], this.externalUser)
      ).toFixed(2));
    },
    showDescription() {
      const maxPercent = pathOr(
        0,
        [
          'props',
          'country_discount_package',
          'props',
          'discount_package',
          'props',
          'max_percent_bonuses_for_payment',
        ],
        this.user
      )
      const countyMax = window.country_max_percent_bonuses_for_payment
      return maxPercent === MAX_PERCENT || countyMax === MAX_PERCENT;
    },
  },
  created() {
    updateUserData.execute().then(({ data }) => {
      this.externalUser = data;
    });
  },
  mounted() {
    this.send({ bonus_sum: 0 });
  },
  methods: {
    ...mapMutations('cart', ['SET_CART']),
    ...mapActions('cart', ['changeCart', 'getCart']),
    setMax(event) {
      if (event > this.userBonus) {
        this.form.bonus_sum = Number(this.userBonus.toFixed(2))
        this.bonus_value = this.userBonus
        return
      }
      this.bonus_value = event
    },
    async prepareData(valid, form) {
      await this.$refs.validator.validate();
      if (!valid) return;
      return this.submit(valid, form || { bonus_sum: this.bonus_value });
    },
    send(data) {
      return applyBonuses.execute({}, { ...data, balance_sum: this.balance || 0 }).then(({ data: response }) => {
        this.info = response;
        this.$emit('input', response);
        this.$refs.validator.reset();
        return this.info
      });
    },
    updateValidator(errors) {
      const parsed = defaultValidatorErrorsParser(errors);
      this.non_field_errors = parsed.non_field_errors;
      this.$refs.validator.setErrors(parsed);
    },
    async removePromo() {
      const question = this._('Отменить списание бонусов?');

      await confirmWithPromise(question, this);
      this.send({ bonus_sum: 0 });
    },
  },
};
</script>
